import n from '../../../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".monaco-editor .view-overlays .debug-top-stack-frame-line{background-color:var(--vscode-editor-stackFrameHighlightBackground)}.monaco-editor .view-overlays .debug-focused-stack-frame-line{background-color:var(--vscode-editor-focusedStackFrameHighlightBackground)}";
n(css,{});
export { css, css as default };
